define('modules/lp_leads/views/lead_listing',['require','exports','module','base/collectionview','./lead_listing_empty_view','./lead_listing_item','modules/lp_info/collections/page_variants','modules/lp_integration/models/integration_status','./integrations_popup','./defaults_popup','ldsh!../templates/lead_listing'],function(require, exports, module) {
  "use strict";

  var CollectionView = require("base/collectionview"),
      LeadListingEmptyView = require("./lead_listing_empty_view"),
      LeadListingItemView = require("./lead_listing_item"),
      PageVariants = require("modules/lp_info/collections/page_variants"),
      IntegrationStatus = require("modules/lp_integration/models/integration_status"),
      IntegrationsPopup = require("./integrations_popup"),
      DefaultsPopup = require("./defaults_popup");

  var LeadListingView = CollectionView.extend({
    initialize: function(options) {
      var model = this.collection.last() || {};
      this._getAllColumnNames();
      this.columnNames = this._getAllColumnNames();
      this.columnHeaders = _.without(this.columnNames, "timestamp", "step");
      this.page = options.page;
      this.variants = new PageVariants([], {page: this.page});
      this.status = new IntegrationStatus({}, {pageId: this.page.id});
      this.listenTo(this.childVent, "integrations:show", this.openIntegrationsPopup);
      this.listenTo(this.childVent, "defaults:show", this.openDefaultsPopup);
      this.status.fetch();
    },
    template: require("ldsh!../templates/lead_listing"),
    tagName: "table",
    className: "ed-table ed-table-striped",
    itemContainer: ".js-tbody",
    itemView: LeadListingItemView,
    emptyViewType: LeadListingEmptyView,
    defaultFormFields: ["ip_address", "http_user_agent", "http_referer", "url_access", "url", "confirmation_url", "variant_name", "page_id", "variant_id", "visit_id"],
    integrationFormFields: ['int_mdirector_response', 'int_webservice_response', 'int_correodirect_response', 'int_zapier_response'],
    createItemView: function() {
      var leadListingItemView = LeadListingView.__super__.createItemView.apply(this, arguments);
      leadListingItemView.setColumnNames(this.columnNames);
      return leadListingItemView;
    },
    onRender: function(){
      this.$el.i18n();
    },
    helpers: function(){
      return {
        pageCount: this.collection.itemCount / this.collection.pageSize,
        currentPage: this.collection.page
      };
    },
    _getAllColumnNames: function(){
      var hiddenFields = _.union(['users_id', '__confirmation_sendparams__'], this.defaultFormFields, this.integrationFormFields);
      //iterate collection and augment the available fields with each lead
      return this.collection.reduce(function(columnNames, lead){
        return _.union(columnNames, _.difference(_.keys(lead.attributes), hiddenFields));
      }, []);
    },
    openIntegrationsPopup: function(view, leadView, lead) {
      var variant = this.variants.find(function(variant){ 
        return variant.get("name") === lead.get("variant_name");
      });
      var properties = variant? variant.get("meta").properties : [];
      var tracking = _.find(properties, function(property){
        return property.skip && property.conditionalExec;
      });
      IntegrationsPopup.show({model: lead, status: this.status, tracking: tracking});
    },
    openDefaultsPopup: function(view, leadView, lead) {
      DefaultsPopup.show(lead.pick(this.defaultFormFields));
    }
  });

  module.exports = LeadListingView;
});

